import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { useCzechSuklRsAtcGroupsExport } from '~/libs/infrastructure/api/availability';
import { handleError } from '~/ErrorHandler';
import downloadFileFromUrl from '~/utils/Download/downloadFileFromUrl';
import type { ThunkDispatch } from '~/Store';

export function useAvailabilityExport() {
	const dispatch: ThunkDispatch<AnyAction> = useDispatch();
	const mutation = useCzechSuklRsAtcGroupsExport();

	async function triggerExport(ids: string[]) {
		try {
			const response = await mutation.mutateAsync({ ids });
			if (response.export.downloadUrl !== null) {
				downloadFileFromUrl(response.export.downloadUrl);
			}
		} catch (error: unknown) {
			dispatch(handleError(error));
		}
	}

	return { triggerExport, isExporting: mutation.isLoading };
}
